import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCheckmarkRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.364 0 13.333 5.969 13.333 13.333S23.363 29.333 16 29.333 2.667 23.363 2.667 16 8.637 2.667 16 2.667m5.65 7.315a1.467 1.467 0 0 0-2.035.402l-5.88 8.779-2.861-2.877a1.467 1.467 0 0 0-2.081 2.07l4.125 4.145a1.47 1.47 0 0 0 2.26-.217l6.874-10.267c.45-.673.27-1.585-.402-2.035" /></svg>;
export default SvgIconCheckmarkRoundedFilledSmall;